/* eslint-disable no-underscore-dangle */
function strMapToObj(strMap) {
  const obj = {};
  strMap.forEach((value, key) => {
    obj[JSON.stringify(key)] = value;
  });
  return obj;
}

function objToStrMap(obj) {
  const strMap = new Map();
  Object.keys(obj).forEach(k => {
    strMap.set(JSON.parse(k), obj[k]);
  });
  return strMap;
}

function strMapToJson(strMap) {
  return JSON.stringify(strMapToObj(strMap));
}

function jsonToStrMap(jsonStr) {
  return objToStrMap(JSON.parse(jsonStr));
}

// eslint-disable-next-line max-classes-per-file
function loadFromLocalStorage() {
  const searchMap = localStorage.getItem('searchMap') || '{}';
  return jsonToStrMap(searchMap);
}

function saveToLocalStorage(map) {
  const json = strMapToJson(map);
  localStorage.setItem('searchMap', json);
}

// A stack (not really) with some extra power:
// + find() to look up entries
// + load() and save() to read/write from localStorage json data
// Based on Map() to guarantee order, have unique keys (searches), and access native size
export class SearchStack {
  constructor() {
    this.load();
  }

  push(q, results) {
    this._map.set(JSON.stringify(q), results);
    this.save();
  }

  find(key) {
    return this._map.get(JSON.stringify(key));
  }

  get size() {
    return this._map.size;
  }

  load() {
    this._map = loadFromLocalStorage();
  }

  save() {
    saveToLocalStorage(this._map);
  }
}
